/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TractorBeamServerDataParser} from "../TractorBeamServerDataParser";

export class TractorBeamParsedInitData extends ParsedInitData {
    private readonly _scatterSymbolWin: number;
    private readonly _totalBetLineWins: number;
    private readonly _totalSpinWinnings: number;
    private readonly _randomFeatureTriggered: boolean;
    private readonly _removedSymbols: string[];
    private readonly _numberOfExtraFreespinsAwarded: number;
    private readonly _scatterExtraSpinPositions: number[];

    // Pick & Click specific members // TODO: By all likeliness obsolete, remove all ocurrences

    constructor(rawData: any, dataParser: TractorBeamServerDataParser) {
        super(rawData, dataParser);
        this._scatterSymbolWin = dataParser.scatterSymbolWin(rawData);
        this._totalBetLineWins = dataParser.totalBetLineWins(rawData);
        this._totalSpinWinnings = dataParser.totalSpinWinnings(rawData);
        this._randomFeatureTriggered = dataParser.randomFeature(rawData);
        this._removedSymbols = dataParser.removedSymbols(rawData);
        this._numberOfExtraFreespinsAwarded = dataParser.numberOfExtraFreespinsAwarded(rawData);
        this._scatterExtraSpinPositions = dataParser.scatterExtraSpinPositions(rawData);
    }

    public get scatterSymbolWin(): number {
        return this._scatterSymbolWin;
    }

    public get isRandomFeature(): boolean {
        return this._randomFeatureTriggered;
    }

    public get removedSymbols(): string[] {
        return this._removedSymbols;
    }

    public get numberOfExtraFreespinsAwarded(): number {
        return this._numberOfExtraFreespinsAwarded;
    }

    public get scatterExtraSpinPositions(): number[] {
        return this._scatterExtraSpinPositions;
    }

}
